export default __webpack_public_path__ + "static/media/image_404.fa399436.png";